import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { bookOfMindSpeech } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Speech/BookOfMindSpeech";
import { ReadState } from "source/app/services/UI/State/ReadState";

const duplicateActivationWindowInMilliseconds = 750;
let lastSpeechToggleAt = 0;

export function ToggleSpeech(fallbackState?: IBookOfMindState) {
    const state =
        ReadState<IBookOfMindState>(ESharedFunction.BookOfMind) ??
        fallbackState;

    if (!state) {
        return;
    }

    const now = Date.now();
    if (
        now - lastSpeechToggleAt <
        duplicateActivationWindowInMilliseconds
    ) {
        return;
    }
    lastSpeechToggleAt = now;

    const isPlaying = state.isSpeechActive;

    const isPaused =
        !state.isSpeechActive && state.spokenQuoteIndex !== undefined;

    if (isPlaying) {
        bookOfMindSpeech.Pause();
        return;
    }

    if (isPaused) {
        bookOfMindSpeech.Resume();
        return;
    }

    bookOfMindSpeech.StartAsync();
}
